<template>
  <v-app id="inspire">
    <v-container class="fill-height fluid">
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="12"
          md="6"
        >
          <v-card
            outlined
            class="mx-10"
          >
            <v-img
              class="mx-auto mt-10"
              max-height="200"
              max-width="200"
              :src="logoB"
            />
            <!-- <div>
            <p class="text-center green--text pt-5 my-0">
              <v-icon>car</v-icon> Pool
            </p>
          </div> -->
            <v-toolbar
              light
              flat
            >
              <v-spacer />
              <p class="mt-5 mb-0 pb-0 text-center headline">
                Reset Password
              </p>
              <div class="flex-grow-1" />
            </v-toolbar>
            <v-alert
              class="mx-5 mb-n3"
              v-model="isError"
              type="error"
              dismissible
            >
              {{ this.errorMessage }}
            </v-alert>
            <v-card-text>
              <br>
              <v-form 
                ref="form" 
                v-model="valid" 
                lazy-validation 
                @submit="login"
                on-submit="return false;"
              >
                <v-text-field
                  outlined
                  v-model="password"
                  :rules="passwordRules"
                  required
                  type="password"
                  label="Input Password"
                  prepend-icon="mdi-lock"
                  ref="passwordRef"
                  placeholder=" "
                />

                <v-text-field
                  outlined
                  v-model="confirmPassword"
                  :rules="confirmPasswordRules"
                  required
                  type="password"
                  label="Confirm Password"
                  prepend-icon="mdi-lock"
                  @keyup.enter="login"
                  ref="passwordConfirmRef"
                  placeholder=" "
                />
              </v-form>
            <!-- <div class="heading"><p class="green--text">Forgot Password ?</p></div> -->
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-btn
                block
                color="#00ACDC"
                type="submit"
                form="form"
                @click="login"
                :loading="loading"
                :disabled="loading"
                class="white--text"
              >
                Send Reset Password
                <template #loader>
                  <span>Loading...</span>
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
const qs = require("qs");
export default {
  props: {
    source: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    valid: true,
    username: "",
    isError: false,
    password: "",
    confirmPassword: "",
    error: false,
    errorMessage: "",
    passwordRules: [(v) => !!v || "Password is required"],
    confirmPasswordRules: [(v) => !!v || "Confrim Password is required"],
    loader: null,
    loading: false,
  }),
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    confirmPassword() {
      this.isError = false;
    },
    password() {
      this.isError = false;
    },
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        if(this.confirmPassword !== this.password) {
          this.errorMessage = "Confirm password didn't match !"
          this.isError = true
        } else {
          const { email_token } = this.$route.params;
          this.loading = true;
          this.loader = this.loading;
          this.$http.post(`${process.env.VUE_APP_API_URL}/reset_password`,
            qs.stringify({
              code: email_token,
              password: this.password
            })
          )
          .then((response) => {
            if(response.data.code == 200) {
              this.loading = false;
              this.loader = this.loading;
              this.$swal({
                icon: "success",
                title: response.data.data.message,
              }).then((res) => {
                if (res.isConfirmed) {
                  this.loading = false;
                  this.loader = this.loading;
                  this.$router.push({ path: "/login" });
                }
              })
            } else {
              this.$swal({
                icon: "error",
                title: response.data.data.message,
              });
              this.loading = false;
              this.loader = this.loading;
            }
          });
        }
      }
    },
  },
  computed: {
    logoB() {
      return process.env.VUE_APP_LOGO_B;
    },
  },
};
</script>